"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var badgeColorMap = {
    base: 'neutral',
    info: 'info-weak',
    success: 'success-weak',
    attention: 'attention-weak',
    critical: 'critical-weak',
    primary: 'primary',
    accent: 'accent',
    outlined: 'base',
};
var labelColorMap = {
    base: 'base',
    success: 'success-weak',
    info: 'on-info-weak',
    attention: 'on-attention-weak',
    critical: 'on-critical-weak',
    primary: 'on-primary',
    accent: 'on-accent',
    outlined: 'on-outline',
};
var sizeMap = {
    sm: (0, classnames_1.default)(' squid-h-component-badge-height-sm '),
    lg: (0, classnames_1.default)('  squid-h-component-badge-height-lg '),
};
var baseClasses = (0, classnames_1.default)(' squid-inline-flex ', ' squid-justify-center ', ' squid-items-center ', ' squid-px-component-badge-padding-base ', ' squid-py-1 ', ' squid-rounded-alias-border-radius-pill ', ' squid-gap-component-badge-space ', ' squid-text-center ');
var Badge = function (_a) {
    var label = _a.label, _b = _a.variant, variant = _b === void 0 ? 'base' : _b, onClose = _a.onClose, _c = _a.size, size = _c === void 0 ? 'sm' : _c, icon = _a.icon, _d = _a.iconSize, iconSize = _d === void 0 ? 'sm' : _d, _e = _a.iconPosition, iconPosition = _e === void 0 ? 'right' : _e, branding = _a.branding, dataTestID = _a["data-testid"], wrap = _a.wrap;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var labelColors = (0, theme_1.useTextColors)(branding);
    var bgClass = bgColors[badgeColorMap[variant]];
    var labelClass = labelColors[labelColorMap[variant]];
    var iconContent = (icon || onClose) && ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)(onClose ? 'squid-cursor-pointer' : '', ' squid-ml-component-badge-space '), onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: iconSize, icon: onClose && !icon ? 'X' : icon, className: labelClass }) })));
    return ((0, jsx_runtime_1.jsxs)("span", __assign({ "data-testid": dataTestID, className: (0, classnames_1.default)(baseClasses, bgClass, variant === 'outlined' ? 'squid-border' : undefined, wrap ? undefined : sizeMap[size]) }, { children: [iconPosition === 'left' && iconContent, (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h6", className: (0, classnames_1.default)('squid-line-height-unset', wrap ? undefined : 'squid-whitespace-nowrap', labelClass), strong: false }, { children: label })), iconPosition === 'right' && iconContent] })));
};
exports.Badge = Badge;
